
import { Vue, Component } from 'vue-property-decorator'
import AMapLoader from '@amap/amap-jsapi-loader'
import { mapKey } from '@/utils/config'
import { ProjectAdd, FileInfo } from '@/types/project'
import { ElForm } from 'element-ui/types/form'
import { twoDecimal } from '@/utils/validate'
import { FetchSuggestionsCallback } from 'element-ui/types/autocomplete'
import UploadFile from '@/components/uploadFile/Index.vue'

@Component({
  components: { UploadFile },
  filters: {
    imgListFormat (list: FileInfo[]) {
      const imgTypeList = ['jpeg', 'jpg', 'png']
      const imgList: Array<string> = []
      list.forEach((item: FileInfo) => {
        const str = item.fileName.split('.')
        if (imgTypeList.find((items) => items === str[str.length - 1].toLowerCase())) {
          imgList.push(item.filePrefix + item.fileUrl)
        }
      })
      return imgList || []
    }
  }
})
export default class Base extends Vue {
  private addrList: object[] = []
  private addr: [string, string, string] = ['', '', '']
  private info: ProjectAdd = {
    projectName: '',
    projectState: '',
    projectProvince: '',
    projectCity: '',
    projectArea: '',
    projectAddr: '',
    longitude: null,
    latitude: null,
    maintStartTime: null,
    maintEndTime: null,
    maintAcreage: '',
    maintUnit: '',
    greenAcreage: '',
    watersAcreage: '',
    projectType: '', // 项目类型
    buildLogo: { // 公司logo
      fileName: '',
      filePrefix: '',
      fileUrl: ''
    },
    buildLogoUrl: '',
    customerLogo: { // 客户公司logo
      fileName: '',
      filePrefix: '',
      fileUrl: ''
    },
    customerLogoUrl: '',
    projectImg: { // 项目总览图片
      fileName: '',
      filePrefix: '',
      fileUrl: ''
    },
    projectImgUrl: ''
  }

  private projectTypeList: Array<{dicValue: string; dicCode: string}>= []

  private startPickerOptions = {
    disabledDate: (time: Date) => {
      if (this.info.maintEndTime && this.info.maintEndTime) {
        return time.getTime() > Number(this.info.maintEndTime)
      } else {
        return false
      }
    }
  }

  private endPickerOptions = {
    disabledDate: (time: Date) => {
      if (this.info.maintStartTime && this.info.maintStartTime) {
        return time.getTime() < Number(this.info.maintStartTime)
      } else {
        return false
      }
    }
  }

  private rules = {
    projectName: [
      { required: true, message: '请输入项目名称', trigger: ['blur', 'change'], whitespace: true }
    ],
    projectState: [
      { required: true, message: '请选择项目状态', trigger: 'change' }
    ],
    projectArea: [
      { required: true, message: '请选择省市区', trigger: 'change' }
    ],
    projectAddr: [
      { required: true, message: '请输入项目详细地址', trigger: ['blur', 'change'] }
    ],
    maintStartTime: [
      { required: true, message: '请选择开始时间', trigger: 'change' }
    ],
    maintEndTime: [
      { required: true, message: '请选择结束时间', trigger: 'change' }
    ],
    maintAcreage: [
      { validator: twoDecimal }
    ],
    greenAcreage: [
      { validator: twoDecimal }
    ],
    watersAcreage: [
      { validator: twoDecimal }
    ]
  }

  private isAdding = false
  private isEdit = true
  $refs!: {
    info: ElForm;
  }

  get projectId () {
    return this.$route.query.projectId || ''
  }

  created () {
    // 新增
    this.getAddrList()
    !this.projectId && this.getProjectTypeList()
    if (this.projectId !== '') {
      this.isEdit = false
      this.getProjectDetail()
    }
  }

  // 获取项目信息
  getProjectDetail () {
    this.$axios.get(this.$apis.project.selectYhProjectByProjectId, { projectId: this.projectId }).then(res => {
      this.info = res || []
    })
  }

  // 获取地址信息
  getAddrList () {
    this.$axios.get(this.$apis.common.getRegion).then(res => {
      this.addrList = res || []
    })
  }

  // 获取项目类型
  getProjectTypeList (callback?: any) {
    this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'projectType' }).then(res => {
      this.projectTypeList = res.projectType || []
      callback && callback()
    })
  }

  getState (state: string) {
    const arr = ['', '未开工', '在建', '已移交']
    return arr[Number(state)]
  }

  areaChange () {
    if (this.addr.length === 3 && this.addr[2] !== '') {
      this.info.projectProvince = this.addr[0] || ''
      this.info.projectCity = this.addr[1] || ''
      this.info.projectArea = this.addr[2] || ''
    } else {
      this.info.projectProvince = ''
      this.info.projectCity = ''
      this.info.projectArea = ''
    }
  }

  // 详细地址输入
  addrFetch (queryString: string, cb: FetchSuggestionsCallback) {
    AMapLoader.load({
      key: mapKey,
      version: '2.0',
      plugins: [
        'AMap.AutoComplete',
        'AMap.Geocoder'
      ]
    }).then(() => {
      // 根据所选区域初始化项目经纬度
      const geocoder = new AMap.Geocoder({
        city: this.info.projectCity
      })
      geocoder.getLocation(this.info.projectArea, (status, result) => {
        const res = result as AMap.Geocoder.GeocodeResult
        if (status === 'complete' && res.geocodes.length) {
          this.info.latitude = res.geocodes[0].location.getLat().toString()
          this.info.longitude = res.geocodes[0].location.getLng().toString()
        }
      })
      // 实例化Autocomplete
      const autoComplete = new AMap.Autocomplete({
        city: this.info.projectCity
      })
      autoComplete.search(this.info.projectArea + queryString, (status, result) => {
        const res = result as AMap.Autocomplete.SearchResult
        if (status === 'complete') {
          cb(res.tips)
        }
      })
    })
  }

  // 点击详细地址下拉
  addrChange (data: AMap.Autocomplete.Tip) {
    this.info.projectAddr = data.name
    this.info.latitude = data.location.getLat().toString()
    this.info.longitude = data.location.getLng().toString()
  }

  // 图片上传成功
  onSuccess1 (file: FileInfo) {
    this.info.buildLogo = file
    this.info.buildLogoUrl = file.filePrefix + file.fileUrl
  }

  onSuccess2 (file: FileInfo) {
    this.info.customerLogo = file
    this.info.customerLogoUrl = file.filePrefix + file.fileUrl
  }

  onSuccess3 (file: FileInfo) {
    this.info.projectImg = file
    this.info.projectImgUrl = file.filePrefix + file.fileUrl
  }

  // 照片删除
  imgRemove (str: string) {
    const arr = ['', 'buildLogo', 'customerLogo', 'projectImg']
    const arr1 = ['', 'buildLogoUrl', 'customerLogoUrl', 'projectImgUrl']
    const key = arr[Number(str)]
    const keys = arr1[Number(str)]
    this.info[key] = {
      fileName: '',
      filePrefix: '',
      fileUrl: ''
    }
    this.info[keys] = ''
  }

  handleAdd () {
    this.$refs.info.validate(valid => {
      if (valid) {
        this.handleTime()
        delete this.info.projectTypeName

        delete this.info.buildLogoUrl
        delete this.info.customerLogoUrl
        delete this.info.projectImgUrl

        if (this.projectId !== '') {
          this.editProject()
        } else {
          this.addProject()
        }
      }
    })
  }

  addProject () {
    this.isAdding = true
    this.$axios.post(this.$apis.project.insertYhProject, this.info).then(() => {
      this.$message.success('添加成功')
      this.$router.back()
      this.$store.dispatch('getProjectList')
      this.$store.dispatch('getNormalProjectList')
    }).catch(() => {
      this.handleTime(true)
      this.$store.dispatch('getProjectList')
      this.$store.dispatch('getNormalProjectList')
    }).finally(() => {
      this.isAdding = false
    })
  }

  // 编辑项目信息
  showEdit () {
    // 查询项目类型字典
    this.getProjectTypeList(() => {
      this.isEdit = true
      this.handleTime(true)
      this.info.buildLogoUrl = this.info?.buildLogo ? `${this.info?.buildLogo?.filePrefix}${this.info?.buildLogo?.fileUrl}` : ''
      this.info.customerLogoUrl = this.info?.customerLogo ? `${this.info?.customerLogo?.filePrefix}${this.info?.customerLogo?.fileUrl}` : ''
      this.info.projectImgUrl = this.info?.projectImg ? `${this.info?.projectImg?.filePrefix}${this.info?.projectImg?.fileUrl}` : ''
      this.addr = [this.info.projectProvince, this.info.projectCity, this.info.projectArea]
    })
  }

  editProject () {
    this.isAdding = true
    this.$axios.post(this.$apis.project.updateYhProject, this.info).then(() => {
      this.$message.success('修改成功')
      this.isEdit = false
      this.getProjectDetail()
      this.$store.dispatch('getProjectList')
      this.$store.dispatch('getNormalProjectList')
    }).catch(() => {
      this.handleTime(true)
      this.$store.dispatch('getProjectList')
      this.$store.dispatch('getNormalProjectList')
    }).finally(() => {
      this.isAdding = false
    })
  }

  // 处理时间格式
  handleTime (type?: boolean) {
    if (type) {
      this.info.maintStartTime = this.info.maintStartTime ? new Date(this.info.maintStartTime).getTime().toString() : null
      this.info.maintEndTime = this.info.maintEndTime ? new Date(this.info.maintEndTime).getTime().toString() : null
    } else {
      this.info.maintEndTime = this.$dayjs(Number(this.info.maintEndTime)).format('YYYY-MM-DD')
      this.info.maintStartTime = this.$dayjs(Number(this.info.maintStartTime)).format('YYYY-MM-DD')
    }
  }
}
